import { ChartProps } from 'react-chartjs-2';
import { green, orange } from '@mui/material/colors';

type FirstVisitDeliveriesChartProps = ChartProps<'doughnut', number[], string>;

export const getFirstVisitDeliveriesChartProps = (
  firstVisitDeliveries: number,
  multiVisitDeliveries: number,
): FirstVisitDeliveriesChartProps => {
  const data: FirstVisitDeliveriesChartProps['data'] = {
    labels: ['Primera visita', 'Revisita'],
    datasets: [
      {
        label: 'Entregas',
        data: [firstVisitDeliveries, multiVisitDeliveries],
        backgroundColor: [green[300], orange[300]],
        borderColor: [green[500], orange[500]],
      },
    ],
  };

  const options: FirstVisitDeliveriesChartProps['options'] = {
    responsive: true,
    cutout: '60%',
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 10,
          },
          boxWidth: 15,
          boxHeight: 15,
          usePointStyle: true,
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `${tooltipItem.label}: ${tooltipItem.parsed}`,
        },
      },
    },
    maintainAspectRatio: false,
  };

  return { data, options, type: 'doughnut' };
};
